/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface VariableValue { 
    path: string;
    value: string | null;
}
export const VariableValue_path_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const VariableValue_value_Validators: ValidatorFn[] =
    [  Validators.required, ];


